module.exports = __webpack_public_path__ + "img/14.d94d1ea8.png";